/** Central application state. */

export interface AppState {
  files: any[];
  loadedFiles: any[];
  classifiedGroups: Record<string, any>;
  classifiedStats: Record<string, { total: number; classes: Record<string, number> }>;
  groupList: any[];
  strategies: Record<string, any>;
  reprocessFiles: any[];
  refGroupsMeta: any[];
  currentRefGroup: string | null;
  currentRefGroupData: any;
  refExtraColumns: string[];
  refEdits: Record<string, Record<string, any>>;
  currentResyncFileId: string | null;
  currentResyncMapping: Record<string, any>;
  currentResyncHeaderRow: number | null;
  currentMassGroup: string | null;
  massResultData: any;
  massSessionId: string | null;
  massFileId: string | null;
  massEdits: Record<string, any>;
  searchStats: Record<string, any>;
  singleParsed: any;
  singleGroup: string | null;
  singleText: string | null;
  singleEditedRequest: any;
  singleStrategyConfig: any;
  singleSearchResult: any;
  singleResult: any;
  refEditsCache: Record<string, any>;
  searchMode: "optimal" | "full";
  columnSettings: string[];
  massPerPage: number;
  currentEditFileId: string | null;
  currentEditFileData: any;
  colLabels: { master_parser: Record<string, string>; sveta_server: Record<string, string> };
  adminOverrides: Record<string, any>;
  editAttrTypes: Record<string, string>;
  editExtraAttrs: any[];
  editParsed: Record<string, any>;
  editingRecordId: number | null;
  bulkEditRecordIds: number[] | null;
  refEditor: any;
  massEditor: any;
  tableEditor: any;
}

export const state: AppState = {
  files: [],
  loadedFiles: [],
  classifiedGroups: {},
  classifiedStats: {},
  groupList: [],
  strategies: {},
  reprocessFiles: [],
  refGroupsMeta: [],
  currentRefGroup: null,
  currentRefGroupData: null,
  refExtraColumns: [],
  refEdits: {},
  currentResyncFileId: null,
  currentResyncMapping: {},
  currentResyncHeaderRow: null,
  currentMassGroup: null,
  massResultData: null,
  massSessionId: null,
  massFileId: null,
  massEdits: {},
  searchStats: {},
  singleParsed: null,
  singleGroup: null,
  singleText: null,
  singleEditedRequest: null,
  singleStrategyConfig: null,
  singleSearchResult: null,
  singleResult: null,
  refEditsCache: {},
  searchMode: "optimal",
  columnSettings: [],
  massPerPage: 100,
  currentEditFileId: null,
  currentEditFileData: null,
  colLabels: { master_parser: {}, sveta_server: {} },
  adminOverrides: {},
  editAttrTypes: {},
  editExtraAttrs: [],
  editParsed: {},
  editingRecordId: null,
  bulkEditRecordIds: null,
  refEditor: null,
  massEditor: null,
  tableEditor: null,
};

export let currentUser: string | null = null;
export let currentUserRole: string | null = "user";

export function setCurrentUser(user: string | null): void {
  currentUser = user;
}

export function setCurrentUserRole(role: string | null): void {
  currentUserRole = role;
}

export let statusInterval: ReturnType<typeof setInterval> | null = null;

export function setStatusInterval(interval: ReturnType<typeof setInterval> | null): void {
  if (statusInterval) clearInterval(statusInterval);
  statusInterval = interval;
}
